module.exports = __webpack_public_path__ + "static/fowf-ian-color-7d0b795fa7426868392266057b858e69.jpg";